import { useState, useEffect } from 'react'
import { searchAPI } from '../api/search.api'
import { ExpertiseData } from '../types/search.types'
import { transformAffaireToExpertiseData } from '../utils/searchHelpers'

export const useExpertisesList = (fmClientId: string) => {
  const [expertises, setExpertises] = useState<ExpertiseData[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchExpertises = async () => {
      if (!fmClientId) {
        setLoading(false)
        setError('Aucun ID client trouvé')
        return
      }

      try {
        setLoading(true)
        const response = await searchAPI.getCustomerExpertises(fmClientId)
        
        if (response.success) {
          const transformedData = (response.data.affairs || []).map(transformAffaireToExpertiseData)
          setExpertises(transformedData)
        } else {
          setError(response.message || 'Échec de la récupération des données')
        }
      } catch (err) {
        console.error('Error fetching expertises:', err)
        setError('Échec de la récupération des données')
      } finally {
        setLoading(false)
      }
    }

    fetchExpertises()
  }, [fmClientId])

  return {
    expertises,
    loading,
    error
  }
}